"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderRow = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Cell = require("../Cell");
var _Row = require("../Row");
require("./HeaderRow.scss");
const HeaderRow = _ref => {
  let {
    row,
    emptyColumnText,
    hasSliderArrows,
    cellClassName
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Row.Row, {
    className: (0, _classnames.default)('cds-ComparisonTableHeaderRow', {
      'cds-ComparisonTableHeaderRow--WithArrows': hasSliderArrows
    })
  }, row.map(cell => /*#__PURE__*/_react.default.createElement(_Cell.Cell, {
    className: (0, _classnames.default)(cellClassName, {
      'cds-ComparisonTableHeaderRow-EmptyCell': !cell.content
    }),
    id: cell.id,
    key: cell.id
  }, cell.content || emptyColumnText)));
};
exports.HeaderRow = HeaderRow;
//# sourceMappingURL=HeaderRow.js.map